import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="center-message">
      <div className="center-message-inner">
        <div className="login-eyebrow">404</div>
        <h1 className="chapter-title">Page not found.</h1>
        <p className="chapter-desc">
          The page you&apos;re looking for doesn&apos;t exist.{' '}
          <Link to="/">Back to the landing page</Link>.
        </p>
      </div>
    </div>
  );
}
